import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";

const AdminFilterAllCandidates = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [batchList, setBatchList] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBatchList = async () => {
      try {
        const response = await axios.get(
          "https://elearn-api.onrender.com/api/getBatchNo"
        );
        const data = response.data;

        if (Array.isArray(data)) {
          const batches = data.map((item) => item.BatchNo);
          setBatchList(batches);
        } else {
          setBatchList([]);
          console.warn("Unexpected response format");
        }
      } catch (error) {
        console.error("Failed to fetch batch list:", error);
        setBatchList([]);
      }
    };

    fetchBatchList();
  }, []);

  const formatDateForAPI = (dateStr) => {
    const date = new Date(dateStr);
    if (isNaN(date)) return null;
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleSearchAll = () => {
    if (!startDate || !endDate || !batchNo) {
      alert("Please select start date, end date, and batch number.");
      return;
    }

    const formattedStart = formatDateForAPI(startDate);
    const formattedEnd = formatDateForAPI(endDate);

    if (!formattedStart || !formattedEnd) {
      alert("Invalid date format");
      return;
    }

    const url = `https://elearn-api.onrender.com/api/mcq-summary-admins-all?startDate=${encodeURIComponent(
      formattedStart
    )}&endDate=${encodeURIComponent(
      formattedEnd
    )}&batchNo=${batchNo}`;

    setLoading(true);
    setError("");
    setResults([]);

    axios
      .get(url)
      .then((res) => {
        const data = res.data;

        if (data && Array.isArray(data) && data.length > 0) {
          setResults(data);
          setError("");
        } else {
          setError("No data found");
          setResults([]);
        }
      })
      .catch((err) => {
        console.error("API error:", err);
        setError("Error fetching data");
        setResults([]);
      })
      .finally(() => setLoading(false));
  };

  // Group candidate info by NRIC (one row per candidate)
  const groupedData = Object.values(
    results.reduce((acc, curr) => {
      const key = curr.NricId;

      if (!acc[key]) {
        acc[key] = {
          Name: curr.Name,
          NricId: curr.NricId,
          DOB: curr.DOB,
          Email: curr.Email?.trim(),
          Mobile: curr.Mobile?.trim(),
          CourseStartDate: curr.CourseStartDate,
          CourseEndDate: curr.CourseEndDate,
           TimeSpent: curr.TimeSpent, 
        };
      }

      return acc;
    }, {})
  );

  return (
    <div className="admin-filter-container">
      <h2>Candidate Info Summary</h2>

      <div className="filter-form">
        <div className="form-group">
          <label>Course Start Date:</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Course End Date:</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Batch No:</label>
          <select value={batchNo} onChange={(e) => setBatchNo(e.target.value)}>
            <option value="">-- Select Batch --</option>
            {batchList.map((b, idx) => (
              <option key={idx} value={b}>
                {b}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <button
            disabled={loading}
            onClick={handleSearchAll}
            className="admin-btn"
          >
            {loading ? "Loading..." : "Search All Candidates"}
          </button>
        </div>
      </div>

      {error && <div className="error">{error}</div>}

      {groupedData.length > 0 && (
        <table className="results-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>NRIC</th>
              <th>Date of Birth</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Course Start</th>
              <th>Course End</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {groupedData.map((candidate, idx) => (
              <tr key={idx}>
                <td>{candidate.Name}</td>
                <td>{candidate.NricId}</td>
                <td>
                  {candidate.DOB
                    ? new Date(candidate.DOB).toLocaleDateString("en-GB")
                    : "-"}
                </td>
                <td>{candidate.Email}</td>
                <td>{candidate.Mobile}</td>
                <td>
                  {candidate.CourseStartDate
                    ? new Date(candidate.CourseStartDate).toLocaleDateString("en-GB")
                    : "-"}
                </td>
                <td>
                  {candidate.CourseEndDate
                    ? new Date(candidate.CourseEndDate).toLocaleDateString("en-GB")
                    : "-"}
                </td>
                 <td>{candidate.TimeSpent} Mins</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminFilterAllCandidates;
